/**
 * @generated SignedSource<<df9573087f275849bd8813c087fdb83b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PartnerToArtistReferralAcceptInput = {
  email: string;
  genre?: any | null;
  location?: string | null;
  name: string;
  password: string;
  phoneNumber?: string | null;
  referral?: any | null;
  socialLinks?: ArtistSocialLinks | null;
  tos: boolean;
  visible?: boolean | null;
};
export type ArtistSocialLinks = {
  instagram?: string | null;
  soundcloud?: string | null;
  spotify?: string | null;
  tiktok?: string | null;
  twitter?: string | null;
  youtube?: string | null;
};
export type ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation$variables = {
  input: PartnerToArtistReferralAcceptInput;
};
export type ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation$data = {
  readonly partnerToArtistReferralAccept: {
    readonly me: {
      readonly " $fragmentSpreads": FragmentRefs<"useAuth_MeFragment">;
    } | null;
  } | null;
};
export type ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation = {
  response: ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation$data;
  variables: ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "data",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentSubscription",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PartnerToArtistReferralAccept",
        "kind": "LinkedField",
        "name": "partnerToArtistReferralAccept",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useAuth_MeFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PartnerToArtistReferralAccept",
        "kind": "LinkedField",
        "name": "partnerToArtistReferralAccept",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canAccessMarketplace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PartnerNode",
                "kind": "LinkedField",
                "name": "partner",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canViewPortfolio",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNode",
                    "kind": "LinkedField",
                    "name": "company",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "isAccepted",
                            "value": true
                          }
                        ],
                        "concreteType": "OfferNodeConnection",
                        "kind": "LinkedField",
                        "name": "offers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OfferNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OfferNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v4/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "offers(isAccepted:true)"
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerNodeConnection",
                        "kind": "LinkedField",
                        "name": "partners",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PartnerNode",
                                        "kind": "LinkedField",
                                        "name": "partner",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "actor",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isActorInterface"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastActiveAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "actor",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileNode",
                                "kind": "LinkedField",
                                "name": "spotifyProfile",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ArtistNode",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyNode",
                        "kind": "LinkedField",
                        "name": "company",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PartnerNode",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "artist",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partnershipStatus",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numIntrosSendable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nextIntroSendableAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stripeConnectedAccountApiId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numUnreadMessages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stripePriceId",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatNodeConnection",
                "kind": "LinkedField",
                "name": "chats",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25229cc0f4ac1158cad987539c65b12a",
    "id": null,
    "metadata": {},
    "name": "ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation",
    "operationKind": "mutation",
    "text": "mutation ClaimYourAccountFlow_PartnerToArtist_Accept_Mutation(\n  $input: PartnerToArtistReferralAcceptInput!\n) {\n  partnerToArtistReferralAccept(data: $input) {\n    me {\n      ...useAuth_MeFragment\n      id\n    }\n  }\n}\n\nfragment AuthUserAvatarName_authUser on UserNode {\n  artist {\n    visible\n    partnershipStatus\n    id\n  }\n  actor {\n    __typename\n    ...AvatarName_actor\n    id\n  }\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment AvatarName_actor on ActorInterface {\n  __isActorInterface: __typename\n  __typename\n  slug\n  displayName\n  ...AvatarIcon_actor\n  ... on PartnerNode {\n    company {\n      slug\n      displayName\n      id\n    }\n  }\n}\n\nfragment ChatThread_authUser on UserNode {\n  id\n  actor {\n    __typename\n    id\n    ...AvatarIcon_actor\n  }\n  userType\n  artist {\n    visible\n    id\n  }\n}\n\nfragment FundPortfolioPage_authUser on UserNode {\n  partner {\n    canViewPortfolio\n    id\n  }\n}\n\nfragment Inbox_authUser on UserNode {\n  numUnreadMessages\n}\n\nfragment ManageSubscription_subscribedUser on UserNode {\n  id\n  partner {\n    displayName\n    id\n  }\n}\n\nfragment PrivateRoute_authUser on UserNode {\n  id\n  email\n  userType\n  name\n  canAccessMarketplace\n}\n\nfragment RowFund_userArtist on UserNode {\n  artist {\n    ...useArtistCanMessageCompany_artist\n    id\n  }\n}\n\nfragment UserInfo_authUser on UserNode {\n  actor {\n    __typename\n    ...AvatarIcon_actor\n    id\n  }\n}\n\nfragment UserNav_authUser on UserNode {\n  userType\n}\n\nfragment useArtistCanMessageCompany_artist on ArtistNode {\n  numIntrosSendable\n  nextIntroSendableAt\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useAuth_MeFragment on UserNode {\n  id\n  email\n  userType\n  ...useCanAccessMarketplace_authUser\n  ...usePartnerCanViewDeals_authUser\n  ...PrivateRoute_authUser\n  ...UserInfo_authUser\n  ...AuthUserAvatarName_authUser\n  ...ChatThread_authUser\n  ...useOfferNextStep_authUser\n  ...Inbox_authUser\n  ...RowFund_userArtist\n  ...UserNav_authUser\n  ...FundPortfolioPage_authUser\n  ...useSubscribedUser\n  ...useUserCanViewChats_authUser\n}\n\nfragment useCanAccessMarketplace_authUser on UserNode {\n  canAccessMarketplace\n}\n\nfragment useOfferNextStep_authUser on UserNode {\n  id\n  stripeConnectedAccountApiId\n}\n\nfragment usePartnerCanViewDeals_authUser on UserNode {\n  partner {\n    canViewPortfolio\n    company {\n      offers(isAccepted: true) {\n        edges {\n          node {\n            __typename\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useSubscribedUser on UserNode {\n  ...ManageSubscription_subscribedUser\n  stripePriceId\n  currentSubscription\n  partner {\n    company {\n      partners {\n        edges {\n          node {\n            user {\n              ...ManageSubscription_subscribedUser\n              currentSubscription\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useUserCanViewChats_authUser on UserNode {\n  chats {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fea5bbb54194203fa38516d9e9dbd40";

export default node;
